import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  .MuiFormControlLabel-labelPlacementStart {
    .MuiFormControlLabel-label {
      text-align: right;
      margin-right: 15px;
    }
  }

  .MuiFormControlLabel-labelPlacementEnd {
    .MuiFormControlLabel-label {
      margin-left: 15px;
    }
  }

  .MuiFormControlLabel-label {
    color: inherit;
    display: inline-block;
    width: 230px;
  }
  `;
